const CALL_REQUIRED_VALUES_WITH_SUMMARY = new Set([
  "yes",
  "archive",
  "archived",
]);

/**
 * Whether the Calling Summary side tab should be visible for an order.
 *
 * @param callRequired - Raw `non_epa_required` value from the order row
 * @returns True when non_epa_required is yes or archived
 */
export const shouldShowCallingSummaryTab = (
  callRequired: string | null | undefined,
): boolean => {
  if (callRequired === null || callRequired === undefined) {
    return false;
  }

  const normalized = String(callRequired).trim().toLowerCase();
  return CALL_REQUIRED_VALUES_WITH_SUMMARY.has(normalized);
};
